import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Form, Formik } from 'formik';

import composeFieldValues from './composeFieldValues';
import { useSearchQuestion, useSearchResults } from '../../../context/DataContext';
import Facets from '../../organisms/Facets/Facets';
import FacetPills from '../../atoms/FacetPills/FacetPills';
import FacetToggle from '../../atoms/FacetToggle/FacetToggle';
import QueryField from '../../atoms/QueryField/QueryField';
import SearchFormContext from '../../../context/SearchFormContext';
import composeFormikValues from './composeFormikValues';
import composeFormURLSearchParams from './composeFormURLSearchParams';

const SearchForm = ({ facetBlockId, formAction, initialExpandFacets, contentHeadings, suggestConfig }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [expandFacets, setExpandFacets] = useState(initialExpandFacets);
  const { config, facets, allFacets, resultsRef, moduleType } = useSearchResults();
  const { setFormQuestion } = useSearchQuestion();
  const facetProps = { id: facetBlockId };
  const facetToggleProps = { expandFacets, facetBlockId, setExpandFacets };
  const maybeFacets = expandFacets ? <Facets {...facetProps} /> : null;

  const handleSearch = (formValues) => {
    const submittedSearchParams = composeFormURLSearchParams(formValues, allFacets);

    let facetParams = {};
    submittedSearchParams.forEach((paramValue, paramKey) => {
      // Do not submit unpopulated facets
      if (!paramValue.trim()) return;

      if (paramKey in facetParams) {
        const previousValue = facetParams[paramKey];
        if (typeof previousValue === 'string') {
          facetParams[paramKey] = [previousValue, paramValue];
        } else {
          facetParams[paramKey] = [...previousValue, paramValue];
        }
      } else {
        facetParams[paramKey] = paramValue;
      }
    });

    // Request new data from Funnelback
    setFormQuestion(formValues.query, facetParams);
    // Set URL search params

    setSearchParams(submittedSearchParams);
  };

  const fieldsConfig = composeFieldValues(allFacets, facets, config?.multiSelectFacetNames, config?.facetExclusions);

  const initialValues = composeFormikValues(searchParams, facets, moduleType);
  const formConfig = { initialValues };

  const maybeForm =
    formConfig && !!fieldsConfig && facets.length ? (
      <SearchFormContext.Provider value={fieldsConfig}>
        <Formik {...formConfig} onSubmit={handleSearch}>
          <Form method="GET" action={formAction} id="base-search-banner__search">
            <div className="container base-search-banner__form">
              <h2 className="search-banner__title">{contentHeadings?.form || 'Search'}</h2>
              <QueryField suggestConfig={suggestConfig} />
              <FacetToggle {...facetToggleProps} />
              {maybeFacets}
            </div>
            <FacetPills />
          </Form>
        </Formik>
        <span ref={resultsRef} className="scroll-anchor"></span>
      </SearchFormContext.Provider>
    ) : null;

  return maybeForm;
};

export default SearchForm;
